import React, { memo } from 'react'

const PDFViewer = ({
  file,
  width = '100%',
  height = '300px',
}) => {
  return (
    <>
      <iframe
        src={`${file}#toolbar=0&navpanes=0`}
        width={width}
        height={height}
        title="pdf viewer"
      />
    </>
  )
}

export default memo(PDFViewer)
